module.exports = __webpack_public_path__ + "static/img/standard-4.1a2fe73a.png";